export const themeColor = '#046307';
export const bgColor = "#faf0e6";
export const themeColorRgb = [4, 99, 7];